import React from "react"
import { useForm } from "react-hook-form"
import { CreateOrUpdateInviteRequest } from "popopo-msg"
import { useToast } from "popopo-lib-front/hook"

type InviteForm = {
  expiredAtSeconds: string
  limit: string
}

export const CreateInviteForm = (props: {
  onCreate: (request: CreateOrUpdateInviteRequest) => Promise<{error: string} | { error: null, createdInviteLink: string, createdInviteKey: string}>,
}) => {
  const toast = useToast()
  const formInvite = useForm<InviteForm>({
    mode: "onBlur",
    defaultValues: {
      expiredAtSeconds: "300",
      limit: "10"
    },
  })

  const { isSubmitting } = formInvite.formState

  return <form className="d-flex flex-column gap-3 w-100">
    <div className="form-floating">
      <input type="number" className="form-control" step={1} {...formInvite.register("expiredAtSeconds")} disabled={isSubmitting} />
      <label>Expired at (Seconds)</label>
    </div>

    <div className="form-floating">
      <input type="number" className="form-control" {...formInvite.register("limit")} disabled={isSubmitting} />
      <label>limit</label>
    </div>

    <button type="button" className="btn btn-primary form-control" onClick={formInvite.handleSubmit(async (values) => {
      const result =await props.onCreate({
        expiredAtSeconds: parseInt(values.expiredAtSeconds, 10) || 300,
        limit: parseInt(values.limit, 10) || 10
      })
      if (result.error !== null) {
        toast.add({ type: "danger", title: "Invite", message: result.error })
      }
    })}>
      Create invite link
    </button>
  </form>
}
